<div class="time-sync-definition">

    <sc-actionbar [footerLine]="true">
        <sc-cancel-button [disabled]="isLoading || !cancelEnabled" (click)="cancel()"></sc-cancel-button>
        <sc-content-spacer></sc-content-spacer>
        <sc-save-button primary (click)="save()" [disabled]="isLoading || !saveEnabled"></sc-save-button>
    </sc-actionbar>

    <div class="details" [formGroup]="detailsFormGroup">
        <div class="field">
            <mat-slide-toggle formControlName="syncArrivalDate" name="syncArrivalDate">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.time-sync-definition.sync-arrival-date"></sc-dictionary-label>
            </mat-slide-toggle>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>
        <div class="field">
            <mat-slide-toggle formControlName="syncProcessingEnd" name="syncProcessingEnd">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.time-sync-definition.sync-processing-end"></sc-dictionary-label>
            </mat-slide-toggle>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>
        <div class="field">
            <mat-slide-toggle formControlName="syncStatusWaiting" name="syncStatusWaiting">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.time-sync-definition.sync-status-waiting"></sc-dictionary-label>
            </mat-slide-toggle>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>
        <div class="field">
            <mat-slide-toggle formControlName="syncStatusProcessing" name="syncStatusProcessing">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.time-sync-definition.sync-status-processing"></sc-dictionary-label>
            </mat-slide-toggle>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>
        <div class="field">
            <mat-slide-toggle formControlName="syncStatusPaused" name="syncStatusPaused">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.time-sync-definition.sync-status-paused"></sc-dictionary-label>
            </mat-slide-toggle>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>
        <div class="field">
            <mat-slide-toggle formControlName="syncStatusCancelled" name="syncStatusCancelled">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.time-sync-definition.sync-status-cancelled"></sc-dictionary-label>
            </mat-slide-toggle>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>
        <div class="field">
            <mat-slide-toggle formControlName="syncStatusFinished" name="syncStatusFinished">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.time-sync-definition.sync-status-finished"></sc-dictionary-label>
            </mat-slide-toggle>
        </div>
    </div>

    <app-service-response [responseMessages]="responseMessages"></app-service-response>
</div>
